module.exports = __webpack_public_path__ + "static/media/app4.afec67e7.png";